import { render, staticRenderFns } from "./ExpiredGiftDialog-gt2.vue?vue&type=template&id=6f2fca33&scoped=true"
import script from "./ExpiredGiftDialog-gt2.vue?vue&type=script&lang=js"
export * from "./ExpiredGiftDialog-gt2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fca33",
  null
  
)

export default component.exports